import { ANALYTICS } from '@ahmdigital/constants';
import { GrowthBook } from '@growthbook/growthbook-react';
import { useEffect } from 'react';

import { getAnalyticsClientId } from '../../../utils/get-analytics-client-id';
import browserUtil from '../utils/browser';
import config from '../config';
import getIsProductionEnv from '../utils/get-is-production-env';
import type { AppFeatures } from '../types/__growthbook__/app-features';

const gb = new GrowthBook<AppFeatures>({
  apiHost: config.get('growthbook:apiHost'),
  clientKey: config.get('growthbook:clientKey'),
  disableCache: !getIsProductionEnv(),
  enableDevMode: !getIsProductionEnv(),
  trackingCallback: (experiment, result) => {
    browserUtil.getWindow().gtag('event', ANALYTICS.EVENTS.ECOMMERCE_GA4.VIEWED_EXPERIMENT, {
      /* eslint-disable camelcase */
      event_category: 'experiment',
      experiment_id: experiment.key,
      send_to: config.get('google:analytics:ga4TrackingId'),
      variation_id: result.variationId,
      /* eslint-enable camelcase */
    });
  },
});

const stripProtocol = (url: string) => url.replace(/^https?:\/\//i, '');

const useInitGrowthBook = (asPath: string) => {
  useEffect(() => {
    gb.init();
  }, []);

  useEffect(() => {
    const setGrowthBookAttributes = async () => {
      const clientId = await getAnalyticsClientId();
      gb.setAttributes({
        id: clientId,
        url: stripProtocol(window.location.href),
      });
    };

    setGrowthBookAttributes();
  }, [asPath]);

  return gb;
};

export default useInitGrowthBook;
